import { api } from './client';

export type BackendSupplierType = 'INPUT_SUPPLIER' | 'OFFTAKER';
export type BackendSupplierStatus = 'ACTIVE' | 'INACTIVE';

export interface BackendSupplier {
  _id: string;
  htxId: string;
  type: BackendSupplierType;
  name: string;
  taxCode?: string;
  phone?: string;
  email?: string;
  address?: string;
  contactPerson?: string;
  status: BackendSupplierStatus;
}

/** Admin-managed Supplier/offtaker master data for one HTX — sourced from
 * GET /suppliers/htx/:htxId (already open to HTX_STAFF, unlike the admin-only
 * write routes). Used to back a real picker instead of a free-text name. */
export async function listSuppliersByHtx(htxId: string, type?: BackendSupplierType, status?: BackendSupplierStatus): Promise<BackendSupplier[]> {
  const query = new URLSearchParams();
  if (type) query.set('type', type);
  if (status) query.set('status', status);
  const qs = query.toString();
  return api.get<BackendSupplier[]>(`/suppliers/htx/${htxId}${qs ? `?${qs}` : ''}`);
}
